import styled from 'styled-components'
import { Box } from '../UI/Box'

const Btn = styled.button`
  cursor: pointer;
  outline: none;
  border: none;

  display: flex;
  gap: 4px;

  padding: 8px 16px;
  color: #ff5e5e;
  background-color: rgba(255, 94, 94, 0.1);
  border-radius: 4px;

  font-size: 14px;

  transition: 0.15s ease-in-out;

  :hover {
    background-color: rgba(255, 94, 94, 0.2);
  }
  :active {
    background-color: rgba(255, 94, 94, 0.3);
  }
  width: auto !important;
`

function ClearButton({
  onClick,
  isVisible,
}: {
  onClick: () => void
  isVisible: boolean
}) {
  if (!isVisible) return null

  return (
    <Box>
      <Btn onClick={onClick}>
        <img
          src="/img/icons/trash.svg"
          width={16}
          height={16}
          alt="Trash icon"
        />
      </Btn>
    </Box>
  )
}

export default ClearButton
